/**
 * Reports service - fetches activity/analytics report from the API.
 * Admin key is read by adminKeyService.
 */

import axios from 'axios';
import { BASE_URL } from './httpClient';
import { getAdminHeaders } from './adminKeyService';

/**
 * Fetch activity report from GET /api/v1/reports/activity.
 * @param {Object} params - Query params: id (required), startDate, endDate, eventName, userId, sessionId, limit
 * @returns {Promise} Axios response with { success, id, count, events }
 */
export const getActivityReport = async (params = {}) => {
    const base = BASE_URL || '';
    const url = `${base}/reports/activity`;
    return axios.get(url, {
        params,
        headers: getAdminHeaders(),
        withCredentials: false
    });
};
